import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import App from './components/Layout'

import './stylesheets/index.scss'

ReactDOM.render(
    <Router>
        <Route path="/:slug">
            <App />
        </Route>
    </Router>,
    document.getElementById('root'),
)
